// Transfere lançamentos do S-26 para o S-44:
// coluna S — "D" e "J" são Entradas; "G" são Despesas.
import { S26_ROW_FIELDS, parseBR, formatBR } from './s26Sync';

const fitRows = (list, max, overflowLabel) => {
  if (list.length <= max) return list;
  const head = list.slice(0, max - 1);
  const rest = list.slice(max - 1);
  head.push({ desc: overflowLabel, value: rest.reduce((a, r) => a + r.value, 0) });
  return head;
};

// Agrupa lançamentos com a mesma descrição em uma única linha, somando os valores.
const groupByDesc = (list) => {
  const map = new Map();
  for (const r of list) {
    const k = r.desc.toUpperCase();
    if (map.has(k)) map.get(k).value += r.value;
    else map.set(k, { ...r });
  }
  return [...map.values()];
};

export function mapS26ToS44(v) {
  const entradas = [];
  const despesas = [];
  for (let n = 1; n <= 52; n++) {
    const f = S26_ROW_FIELDS(n);
    const s = (v[f.simbolo] || '').toUpperCase().trim();
    const desc = (v[f.desc] || '').trim();
    const entrada = parseBR(v[f.donE]) + parseBR(v[f.contaE]) + parseBR(v[f.outraE]);
    const saida = parseBR(v[f.donS]) + parseBR(v[f.contaS]) + parseBR(v[f.outraS]);
    if (!desc && entrada === 0 && saida === 0) continue;
    // A (Aplicação) e R (Resgate) são movimentações internas: não vão para o S-44.
    if (s === 'A' || s === 'R') continue;
    const valor = entrada > 0 ? entrada : saida;
    // Classificação estrita pelo símbolo: D/J → Entradas, G → Despesas (sem duplicar transferências internas).
    if (s === 'D' || s === 'J') entradas.push({ desc: desc || `Entrada (linha ${n})`, value: valor });
    else if (s === 'G') despesas.push({ desc: desc || `Despesa (linha ${n})`, value: valor });
    else if (entrada > 0) entradas.push({ desc: desc || `Entrada (linha ${n})`, value: entrada });
    else if (saida > 0) despesas.push({ desc: desc || `Despesa (linha ${n})`, value: saida });
  }

  const ent = fitRows(groupByDesc(entradas), 8, 'Outras entradas');
  const desp = fitRows(groupByDesc(despesas), 13, 'Outras despesas');

  const out = {};
  // Limpa as linhas de Entradas/Despesas do S-44 antes de preencher (campos com passo 2).
  for (let i = 0; i < 8; i++) { out[`900_${4 + 2 * i}_Text`] = ''; out[`901_${5 + 2 * i}_S44Rec`] = ''; }
  for (let i = 0; i < 13; i++) { out[`900_${21 + 2 * i}_Text`] = ''; out[`901_${22 + 2 * i}_S44Ex`] = ''; }
  ent.forEach((r, i) => {
    out[`900_${4 + 2 * i}_Text`] = r.desc;
    out[`901_${5 + 2 * i}_S44Rec`] = r.value > 0 ? formatBR(r.value) : '';
  });
  desp.forEach((r, i) => {
    out[`900_${21 + 2 * i}_Text`] = r.desc;
    out[`901_${22 + 2 * i}_S44Ex`] = r.value > 0 ? formatBR(r.value) : '';
  });

  const totalE = entradas.reduce((a, r) => a + r.value, 0);
  const totalD = despesas.reduce((a, r) => a + r.value, 0);
  out['901_20_S44TotalRec'] = totalE > 0 ? formatBR(totalE) : '';
  out['901_47_S44TotalEx'] = totalD > 0 ? formatBR(totalD) : '';
  out['901_48_S44SurDef'] = (totalE || totalD) ? formatBR(totalE - totalD) : '';

  const mes = (v['900_4_Text_C'] || '').trim();
  const ano = (v['900_5_Text_C'] || '').trim();
  if (mes || ano) out['900_2_Text'] = [mes, ano].filter(Boolean).join('/');

  return { values: out, counts: { entradas: entradas.length, despesas: despesas.length }, totals: { entradas: totalE, despesas: totalD } };
}
